module.exports = __webpack_public_path__ + "assets/img/code611.2f327979.png";